<template>
  <div>
    <div v-if="![0].includes(externalSoftware)" style="font-size: 22px; font-weight: bold; padding: 60px">
      {{ $t('export.comp.bmdOnly') }}
    </div>
    <div v-else class="main-view-padding has-header">
      <div class="header main">
        <div class="align-left">
          <!-- <dateselectionheader :label="dateDisplay" @PrevDate="modDate('sub')" @NextDate="modDate('add')" /> -->
        </div>
        <div class="align-middle">
          <headerbuttonstack :state="headerButtons" />
        </div>
        <div class="align-right">
          <headerbuttonstack :state="sideButtons" />
        </div>
      </div>
      <div v-if="stage === 1" class="sub-header">
        {{ $t('export.comp.employeeExits') }}
      </div>
      <div v-if="stage === 2" class="sub-header">
        {{ $t('export.comp.exportOverview') }}
      </div>

      <div v-if="loading">
        <i class="fas fa-circle-notch fa-spin"></i> {{ ' ' + $t('employee.collective.pleaseWait') }}<br/>
          {{ $t('export.comp.loadingEmployeeExits') }}<br/>
        <div
          style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
        ></div>
      </div>

      <div class="parentBox" v-if="!loading && stage === 1">

        <div class="settings xColumn2">

          <div class="header">{{ $t('export.comp.settingsContent') }}</div>

          <!-- exit date -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.exitDateFrom') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <span>{{ exitDateFromItems[employeeExitSettings.exitDateFrom] }}</span>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <select class="modern-select" v-model="employeeExitSettings_input.exitDateFrom" style="width: 98%">
                <option
                  v-for="(entry, key) in exitDateFromItems"
                  :value="key"
                  :key="key"
                >
                  {{ entry }}
                </option>
              </select>
            </div>
          </div>
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.exitDateTo') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <span>{{ exitDateToItems[employeeExitSettings.exitDateTo] }}</span>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <select class="modern-select" v-model="employeeExitSettings_input.exitDateTo" style="width: 98%">
                <option
                  v-for="(entry, key) in exitDateToItems"
                  :value="key"
                  :key="key"
                >
                  {{ entry }}
                </option>
              </select>
            </div>
          </div>
          <!-- termination compensation until -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.terminationCompensationUntil') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <span>{{ terminationCompensationUntilItems[employeeExitSettings.terminationCompensationUntil] }}</span>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <select class="modern-select" v-model="employeeExitSettings_input.terminationCompensationUntil" style="width: 98%">
                <option
                  v-for="(entry, key) in terminationCompensationUntilItems"
                  :value="key"
                  :key="key"
                >
                  {{ entry }}
                </option>
              </select>
            </div>
          </div>
          <!-- rehire -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.reemploymentPromise') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <span>{{ rehireItems[employeeExitSettings.rehire] }}</span>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <select class="modern-select" v-model="employeeExitSettings_input.rehire" style="width: 98%">
                <option
                  v-for="(entry, key) in rehireItems"
                  :value="key"
                  :key="key"
                >
                  {{ entry }}
                </option>
              </select>
            </div>
          </div>
          <!-- elda deregistration -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.createEldaDeregistration') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !employeeExitSettings.createEldaDeregistration }"></i>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eac'"
                v-bind:class="{ false: !employeeExitSettings_input.createEldaDeregistration }"
                v-on:click="employeeExitSettings_input.createEldaDeregistration = !employeeExitSettings_input.createEldaDeregistration"></i>
            </div>
          </div>
          <!-- doRolloffWorkflow -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.runExitWorkflow') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !employeeExitSettings.doRolloffWorkflow }"></i>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eac'"
                v-bind:class="{ false: !employeeExitSettings_input.doRolloffWorkflow }"
                v-on:click="employeeExitSettings_input.doRolloffWorkflow = !employeeExitSettings_input.doRolloffWorkflow"></i>
            </div>
          </div>

        </div>

        <div class="settings xColumn2">

          <div class="header">{{ $t('export.comp.exportSettings') }}</div>

          <!-- enableExportViaTransferService -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.enableAutomaticExports') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !employeeExitSettings.enableExportViaTransferService }"></i>
            </div>
            <div v-if="!saves && editing" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eevts'"
                v-bind:class="{ false: !employeeExitSettings_input.enableExportViaTransferService }"
                v-on:click="employeeExitSettings_input.enableExportViaTransferService = !employeeExitSettings_input.enableExportViaTransferService"></i>
            </div>
          </div>
          <!-- enablePeriodicExport -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.enablePeriodicExport') }}</div>
            <div v-if="saves || !editing" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !employeeExitSettings.enablePeriodicExport }"></i>
            </div>
            <div v-if="!saves && editing" class="entryData" style="display:flex; justify-content:space-between">
              <i class="fas fa-check-circle checkbox" :key="'cb-epe'"
                v-bind:class="{ false: !employeeExitSettings_input.enablePeriodicExport }"
                v-on:click="employeeExitSettings_input.enablePeriodicExport = !employeeExitSettings_input.enablePeriodicExport"></i>
              <i v-if="employeeExitSettings_input.enablePeriodicExport" class="fas fa-plus" v-tooltip="$t('export.builder.addTime')"
                v-on:click="periodicExportTimes_input.push({type: 0, dayOfMonth: 0, dayOfWeek: 0, hours: 0, minutes: 0})"></i>
            </div>
          </div>
          <!-- periodic export times -->
          <div v-if="(saves || !editing) && employeeExitSettings.enablePeriodicExport">
            <div v-for="time in periodicExportTimes" v-bind:key="time.id" class="entryBox">
              <div class="entryHeader" style="text-align: right; padding-right: 10px">{{ periodicExportTimeTypes.find(e => e.value === time.type).label }}</div>
              <div class="entryData">{{ getPeriodicTimeLabel(time) }}</div>
            </div>
          </div>
          <div v-if="!saves && editing && employeeExitSettings_input.enablePeriodicExport">
            <div v-for="(time, index) in periodicExportTimes_input" :key="index" class="entryBox">
              <div class="entryHeader">
                <select class="modern-select" v-model="time.type" style="width: 98%">
                  <option v-for="item in periodicExportTimeTypes" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
              <div class="entryData">
                <select class="modern-select" v-if="time.type === 1" v-model="time.dayOfWeek" style="width: 150px">
                  <option v-for="item in getPeriodicTimeTypeInputs(time.type)" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
                <select class="modern-select" v-if="time.type === 2" v-model="time.dayOfMonth" style="width: 150px">
                  <option v-for="item in getPeriodicTimeTypeInputs(time.type)" :value="item.value" :key="item.value">
                    {{ item.label }}
                  </option>
                </select>
                &nbsp;
                <input v-model.number="time.hours" type="number" style="width: 27px" @input="onHoursInput(time)" />
                :
                <input v-model.number="time.minutes" type="number" style="width: 27px" @input="onMinutesInput(time)" />
                &nbsp;
                <i v-tooltip="$t('export.builder.deleteTime')" class="fas fa-trash" v-on:click="deletePeriodicExportTime(index)" />
              </div>
            </div>
          </div>

        </div>

        <div class="preview">
          <div class="sub-header" style="display: flex; justify-content: space-between;">
            <div>{{ $t('export.builder.exportPreview') }}</div>
            <div style="text-align: right;" v-if="!buildingPreviewTable" class="">
              <buttonc
                :label="$t('export.comp.regeneratePreview')"
                class=""
                type="no-border"
                @click="loadPreview()"
              />
            </div>
          </div>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th>{{ $t('employee.core.firstName') }}</th>
                  <th>{{ $t('employee.core.lastName') }}</th>
                  <th>{{ $t('export.comp.exitDate') }}</th>
                  <th>{{ $t('employee.contract.exitReason') }}</th>
                </tr>
              </thead>
              <tbody v-if="buildingPreviewTable">
                <tr>
                  <td colspan="4">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <br /><strong>{{ $t('export.comp.tableGenerating') }}</strong>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="Object.values(preview).length > 0">
                <tr v-for="entry in preview" v-bind:key="entry.employeeId">
                  <td>{{ employeeById[entry.remoteId].firstName }}</td>
                  <td>{{ employeeById[entry.remoteId].lastName }}</td>
                  <td>{{ $helpers.getMomentFromStringTZ(entry.to).subtract(1, 'days').format('L') }}</td>
                  <td>{{ entry.exitReason ? exitReasonArray[entry.exitReason] : "" }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4">{{ $t('export.comp.noNewExits') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="parentBox" v-if="!loading && stage === 2">

        <table class="table">
          <tr>
            <th>{{ $t('settings.sync.startedBy') }}</th>
            <th>{{ $t('settings.sync.exportStarted') }}</th>
            <th>{{ $t('settings.sync.exportFinished') }}</th>
            <th>{{ $t('global.ui.type') }}</th>
            <th>{{ $t('settings.sync.status') }}</th>
            <th>{{ $t('export.comp.importedInExternalTool') }}</th>
            <th>{{ $t('settings.sync.downloadCsv') }}</th>
          </tr>
          <tr v-for="exportJob in exportJobsSorted" v-bind:key="exportJob.id">
            <td>{{ authusers[exportJob.authuserId].name }}</td>
            <td>{{ exportJob.jobStarted }}</td>
            <td>{{ exportJob.jobEnded }}</td>
            <td>{{ exportJob.manualDownload
                ? $t('export.comp.manualDownload')
                : $t('export.comp.exportToLv')
                }}</td>
            <td>
              <i v-if="exportJob.status === 'FAILED'" style="color: red" class="fas fa-xmark" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
              <i v-if="exportJob.status === 'DONE'" style="color: green" class="fas fa-check"></i>
              <i v-if="exportJob.status === 'IGNORE-WARNING'" style="color: orange" class="fas fa-check" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
              <i v-if="exportJob.status === 'WARNING'" style="color: orange" class="fas fa-check" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
              <i v-if="exportJob.status === 'WARNING'" style="color: orange" class="fas fa-triangle-exclamation" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
            </td>
            <td>
              <div>
                <i class="fas fa-check-circle checkbox" :key="'cb-ufdc-' + exportJob.id"
                  v-bind:class="{ false: !exportJob.useForDeltaCalculation }"
                  v-on:click="exportJob.useForDeltaCalculation = !exportJob.useForDeltaCalculation; setDeltaCalculationFlag(exportJob)"></i>
              </div>
            </td>
            <td>
              <i v-if="exportJob.exportCSV" class="fas fa-file-download" v-on:click="downloadCSVFromExportJob(exportJob.exportCSV)"></i>
            </td>
          </tr>
        </table>

      </div>

    </div>

    <b-modal size="lg" ref="modal-exportjob-status" @close="closeExportJobStatusModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">{{ $t('export.comp.exportDetails') }}</div>
        </div>
      </template>
      <b-container fluid>
        <div v-if="selectedExportJob && selectedExportJob.status === 'FAILED'" class="full">
            {{ $t('export.comp.exportFailed') }}
        </div>
        <div v-if="selectedExportJob && selectedExportJob.status === 'IGNORE-WARNING'" class="full">
            {{ $t('export.comp.exportSuccessWithWarnings') }}<br>
            {{ $t('export.comp.skippedEmployeesDueToSettings') }}<br>
            <table v-if="getInactiveEmployeeWarnings(selectedExportJob).length > 0">
            <th><td><br>{{ $t('export.comp.skippedInactiveEmployees') }}</td></th>
            <tr v-for="emp in getInactiveEmployeeWarnings(selectedExportJob)" v-bind:key="emp.employeeId"><td>{{ getEmployeeName(emp.employeeId) }}</td></tr>
          </table>
          <table v-if="getExternalEmployeeWarnings(selectedExportJob).length > 0">
            <th><td><br>{{ $t('export.comp.skippedExternalEmployees') }}</td></th>
            <tr v-for="emp in getExternalEmployeeWarnings(selectedExportJob)" v-bind:key="emp.employeeId"><td>{{ getEmployeeName(emp.employeeId) }}</td></tr>
          </table>
          <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && showHiddenWarnings">
            <th><td><br>{{ $t('export.comp.skippedHiddenEmployees') }}
              <i class="fas fa-chevron-circle-up" style="padding-left: 5px" v-on:click="showHiddenWarnings = !showHiddenWarnings"/>
            </td></th>
            <tr v-for="emp in getHiddenEmployeeWarnings(selectedExportJob)" v-bind:key="emp.employeeId"><td>{{ getEmployeeName(emp.employeeId) }}</td></tr>
          </table>
          <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && !showHiddenWarnings">
            <th><td><br>{{ $t('export.comp.skippedHiddenEmployees') }}
              <i class="fas fa-chevron-circle-down" style="padding-left: 5px" v-on:click="showHiddenWarnings = !showHiddenWarnings"/>
            </td></th>
          </table>
        </div>
        <div v-if="selectedExportJob && selectedExportJob.status === 'WARNING'" class="full">
            {{ $t('export.comp.exportSuccess') }}<br>
            {{ $t('export.comp.exportWarningsOccurred') }}<br>
            <table v-for="table in getOtherWarningsTable(selectedExportJob)" v-bind:key="table.name">
            <th><td><br>{{ warningTranslations[table.name] }}</td></th>
            <tr v-for="empId in table.emps" v-bind:key="empId"><td>{{ getEmployeeName(empId) }}</td></tr>
          </table>
          <table v-if="getInactiveEmployeeWarnings(selectedExportJob).length > 0">
            <th><td><br>{{ $t('export.comp.skippedInactiveEmployees') }}</td></th>
            <tr v-for="emp in getInactiveEmployeeWarnings(selectedExportJob)" v-bind:key="emp.employeeId"><td>{{ getEmployeeName(emp.employeeId) }}</td></tr>
          </table>
          <table v-if="getExternalEmployeeWarnings(selectedExportJob).length > 0">
            <th><td><br>{{ $t('export.comp.skippedExternalEmployees') }}</td></th>
            <tr v-for="emp in getExternalEmployeeWarnings(selectedExportJob)" v-bind:key="emp.employeeId"><td>{{ getEmployeeName(emp.employeeId) }}</td></tr>
          </table>
          <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && showHiddenWarnings">
            <th><td><br>{{ $t('export.comp.skippedHiddenEmployees') }}
              <i class="fas fa-chevron-circle-up" style="padding-left: 5px" v-on:click="showHiddenWarnings = !showHiddenWarnings"/>
            </td></th>
            <tr v-for="emp in getHiddenEmployeeWarnings(selectedExportJob)" v-bind:key="emp.employeeId"><td>{{ getEmployeeName(emp.employeeId) }}</td></tr>
          </table>
          <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && !showHiddenWarnings">
            <th><td><br>{{ $t('export.comp.skippedHiddenEmployees') }}
              <i class="fas fa-chevron-circle-down" style="padding-left: 5px" v-on:click="showHiddenWarnings = !showHiddenWarnings"/>
            </td></th>
          </table>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div v-if="selectedExportJob && selectedExportJob.status === 'FAILED'" class="button right"
             @click="openInNewTab('https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11'); closeExportJobStatusModal()">
          <div class="label">{{ $t('export.comp.contactSupport') }}</div>
        </div>
        <div class="button right" @click="closeExportJobStatusModal()">
          <div class="label">{{ $t('global.ui.close') }}</div>
        </div>
      </template>
    </b-modal>

  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import VueEventBus from "@/vue-event-bus";
export default {
  components: {},
  name: "ExportEmployeeExits",
  data() {
    return {
      loading: false,
      stage: 1,
      loadingExport: false,
      loadingDownload: false,
      settingsUpdated: false,
      buildingPreviewTable: false,
      saves: false,
      editing: false,

      exportJobs: [],
      preview: [],
      selectedExportJob: null,
      authusers: [],
      employeeById: {},

      exitReasonArray: [],

      // default settings
      employeeExitSettings: {
        exitDateFrom: 1,
        exitDateTo: 0,
        terminationCompensationUntil: 3,
        createEldaDeregistration: false,
        rehire: 0,
        doRolloffWorkflow: true,

        enableExportViaTransferService: false,
        enablePeriodicExport: false,
      },
      employeeExitSettings_input: {},

      periodicExportTimes: [],
      periodicExportTimes_input: [],

      // items for selects
        exitDateFromItems: {
            0: this.$t('export.comp.exportAllExits'),
            1: this.$t('export.comp.exportLast14Days'),
            2: this.$t('export.comp.exportLast30Days')
        },
        exitDateToItems: {
            0: this.$t('export.comp.exportAllExits'),
            1: this.$t('export.comp.exportUntilToday'),
            2: this.$t('export.comp.exportNext14Days'),
            3: this.$t('export.comp.exportUntilEndOfMonth')
        },
        terminationCompensationUntilItems: {
            0: this.$t('export.comp.noTerminationCompensation'),
            1: this.$t('export.comp.compensationUntilEndOfExitMonth'),
            2: this.$t('export.comp.compensation1Month'),
            3: this.$t('export.comp.compensation3Months')
        },
        rehireItems: {
            0: this.$t('export.comp.takeFromEmployeeRecord'),
            1: this.$t('export.comp.yes'),
            2: this.$t('export.comp.no')
        },
        periodicExportTimeTypes: [
            { value: 0, label: this.$t('export.comp.daily') },
            { value: 1, label: this.$t('export.comp.weekly') },
            { value: 2, label: this.$t('export.comp.monthly') }
        ]
    };
  },
  computed: {
    ...mapGetters([
      "companyId",
      "externalSoftware",
      "employeeArray",
      "uiDataMap"
    ]),
    headerButtons() {
      let view = this;

      let state = {
        buttons: [
          {
            type: "block border-r",
            icon: "fa-refresh",
            show: !view.editing,
            disabled: view.loading || view.loadingExport || view.loadingDownload || view.settingsUpdated,
            click: () => {
              view.refresh();
            },
            tooltip: view.$t('settings.wage.reloadData'),
          },
          {
            type: "block border-r",
            icon: "fa-edit",
            show: view.stage === 1 && !view.saves && !view.editing,
            disabled: view.loading || view.loadingDownload || view.loadingExport,
            click: () => {
              view.editing = !view.editing;
            },
            tooltip: view.$t('settings.ui.edit'),
            title: view.$t('settings.ui.edit'),
          },
          {
            type: view.employeeExitSettings && view.employeeExitSettings.enableExportViaTransferService ? "block" : "block border-r",
            icon: "fa-file-download",
            show: view.stage === 1 && view.employeeExitSettings && !view.loadingDownload && !view.editing,
            disabled: view.loading || view.loadingExport,
            click: () => {
              view.openDownloadCsvPopup();
            },
            tooltip:  view.$t('settings.sync.downloadExport') ,
            title:  view.$t('settings.sync.downloadExport') ,
          },
          {
            show: view.stage === 1 && view.loadingDownload,
            type: view.employeeExitSettings && view.employeeExitSettings.enableExportViaTransferService ? "block" : "block border-r",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip:  view.$t('settings.sync.downloadGen') ,
          },
          {
            type: "block border-r",
            icon: "fa-file-export",
            show: view.stage === 1 && !view.loadingExport && view.employeeExitSettings && view.employeeExitSettings.enableExportViaTransferService && !view.editing,
            disabled: view.loading || view.loadingDownload,
            click: () => {
              view.exportCSV();
            },
            tooltip:  view.$t('settings.sync.exportLV') ,
            title:  view.$t('settings.sync.exportLV') ,
          },
          {
            show: view.stage === 1 && view.loadingExport,
            type: "block border-r",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip:  view.$t('settings.sync.downloadGen') ,
          },
          {
            type: "block border-r",
            icon: "fa-magnifying-glass",
            show: view.stage === 1 && !view.saves && !view.editing && ((view.employeeExitSettings && view.employeeExitSettings.enableExportViaTransferService) || view.exportJobsSorted.length > 0),
            disabled: view.loading || view.loadingDownload || view.loadingExport,
            click: () => {
              view.stage = 2;
            },
            tooltip:  view.$t('settings.sync.viewExport') ,
            title:  view.$t('settings.sync.viewExport') ,
          },
          {
            type: "block border-r",
            icon: "fa-chevron-left",
            show: view.stage === 2,
            click: () => {
              view.stage = 1;
            },
            tooltip: this.$t('export.builder.backToExport'),
            title: this.$t('export.builder.backToExport'),
          },
          {
            type: "block red",
            icon: "fa-ban",
            show: view.stage === 1 && !view.saves && view.editing,
            click: () => {
              view.resetInputs();
              view.editing = !view.editing;
            },
            tooltip: view.$t('settings.ui.cancel'),
          },
          {
            type: "block green",
            icon: "fa-save",
            show: view.stage === 1 && !view.saves && view.editing,
            click: () => {
              view.save();
            },
            tooltip:  view.$t('settings.ui.saveChanges') ,
          },
          {
            show: view.stage === 1 && view.saves,
            type: "block",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip:  view.$t('settings.ui.saving') ,
          },
      ],
        helperLinks: [
          {
              title: this.$t('export.comp.getSupport'),
              helperText: this.$t('export.comp.supportInstructions'),
              externalUrl:
                "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
            externalLabel:  view.$t('settings.sync.contactSupport') ,
            cancelLabel: view.$t('global.ui.close'),
          }
        ]
      };

      state.buttons.push();

      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [],
      };

      return state;
    },
    exportJobsSorted() {
      return this.exportJobs.sort((a,b) => {
        if (a.created_at > b.created_at) {
          return -1;
        } else if (b.created_at > a.created_at) {
          return 1;
        } else {
          return 0;
        }
      });
    },
  },
  watch: {
    companyId: function (newVal, oldVal) {
      this.refresh();
    },
  },
  created: function () {
    //console.log("CREATED");
    VueEventBus.$on("JobEmployeeExitExportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobEmployeeExitExportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobEmployeeExitExportEvent:jobEnded", this.jobEnded);
    VueEventBus.$on("JobEmployeeExitExportEvent:jobFailed", this.jobFailed);
  },
  beforeDestroy: function () {
    VueEventBus.$off("JobEmployeeExitExportEvent:jobCreated", null);
    VueEventBus.$off("JobEmployeeExitExportEvent:jobStarted", null);
    VueEventBus.$off("JobEmployeeExitExportEvent:jobEnded", null);
    VueEventBus.$off("JobEmployeeExitExportEvent:jobFailed", null);
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh: function () {
      let view = this;
      view.loading = true;
      view.employeeExitSettings_input = JSON.parse(JSON.stringify(view.employeeExitSettings));

      view.exportJobs = [];

      let promises = [];
      promises.push(view.$helpers.GetEmployeeArray());
      promises.push(view.prepareEmployeeExitSettings());
      promises.push(view.preparePeriodicExportTimes());
      promises.push(view.loadExportJobs());
      promises.push(view.loadPreview());
      promises.push(view.setupUIDataMaps());

      Promise.all(promises).finally(() => {
        view.employeeById = view.employeeArray.reduce((map, obj) => {
          map[obj.id] = obj;
          return map;
        }, {});
        view.loading = false;
      });
    },

    // helpers
    loadAuthuser(id) {
      let view = this;
      if (!view.authusers.hasOwnProperty(id)) {
        view.authusers[id] = {
          id: id,
          uuid: "",
          name: this.$t('export.comp.periodicStart'),
          mail: ""
        };
        let baseurl = '/api/sec/authuser';
        let url = baseurl;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
        url = this.$helpers.appendParam("id", id, url, baseurl);

        return this.axios({
          method: 'get',
          headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
          url: url,
        }).then(response => {
          view.authusers[id] = response.data.data;
        }).catch(function (error) {
          console.log(error);
        })
      } else {
        return Promise.resolve();
      }
    },
    setupUIDataMaps() {
      this.uiDataMap.exitReasons.forEach(item => this.exitReasonArray[item.id] = item.label_de);
    },
    resetInputs() {
      let view = this;

      view.employeeExitSettings_input = JSON.parse(JSON.stringify(view.employeeExitSettings));
      view.periodicExportTimes_input = JSON.parse(JSON.stringify(view.periodicExportTimes));

    },
    save() {
      let view = this;
      view.saves = true;

      let promises = [];

      promises.push(view.saveEmployeeExitSettings()
      .then((response) => {
        view.employeeExitSettings_input.id = response.data.id;
        view.employeeExitSettings = JSON.parse(JSON.stringify(view.employeeExitSettings_input));
        // view.$helpers.info(
        //   "Speichern erfolgreich",
        //   "Mitarbeiter Sync Einstellungen wurde erfolgreich gespeichert"
        // );
        // VueEventBus.$emit("EmployeeExitSettingsEvent:updated", view.employeeExitSettings);
      }));
      promises.push(view.savePeriodicExportTimes()
      .then(response => {
        view.periodicExportTimes = JSON.parse(JSON.stringify(response.data.data));
        view.periodicExportTimes_input = JSON.parse(JSON.stringify(response.data.data));
      }));

      Promise.all(promises)
      .then((resp) => {
        view.editing = false;
        view.saves = false;
        view.$helpers.success(
            view.$t('settings.ui.saveSuccessTitle'),
            view.$t('settings.ui.saveSuccessMessage')
        );
        view.loadPreview();
      })
      .catch(function (error) {
        console.log(error);
        view.editing = false;
        view.saves = false;
        view.$helpers.error(
            view.$t('export.comp.periodicStart'),
            view.$t('export.comp.saveDataError')
        );
      });
    },

    // settings
    prepareEmployeeExitSettings() {
      let view = this;
      view.employeeExitSettings = {
        id: -1,
        exitDateFrom: 1,
        exitDateTo: 0,
        terminationCompensationUntil: 3,
        createEldaDeregistration: false,
        rehire: 0,
        doRolloffWorkflow: true,

        enableExportViaTransferService: false,
        enablePeriodicExport: false,
      };
      view.employeeExitSettings_input = JSON.parse(JSON.stringify(view.employeeExitSettings));
      view.getEmployeeExitSettings()
        .then((settings) => {
          view.employeeExitSettings = JSON.parse(JSON.stringify(settings));
          view.employeeExitSettings_input = JSON.parse(JSON.stringify(settings));
        });
    },
    getEmployeeExitSettings() {
      return this.$helpers.GetCall('/api/sec/employeeexit/settings').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    saveEmployeeExitSettings() {
      let view = this;

      let method = 'post';
      let url = '/api/sec/employeeexit/settings';
      if (view.employeeExitSettings.id !== -1) {
        url = url + '/' + view.employeeExitSettings.id;
        method = 'put';
      }
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: view.employeeExitSettings_input
      }).catch(function (error) {
        view.employeeExitSettings_input = JSON.parse(JSON.stringify(view.employeeExitSettings));
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('export.comp.saveSettingsError')
        );
      });
    },

    // periodic export
    preparePeriodicExportTimes() {
      let view = this;

      view.periodicExportTimes = [];
      view.periodicExportTimes_input = [];

      this.loadPeriodicExportTimes()
      .then((response) => {
        view.periodicExportTimes = JSON.parse(JSON.stringify(response));
        view.periodicExportTimes_input = JSON.parse(JSON.stringify(response));
      });
    },
    loadPeriodicExportTimes() {
      return this.$helpers.GetCall('/api/sec/employeeexit/periodicExportSettings').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    savePeriodicExportTimes() {
      let view = this;

      let payload = {
        data: view.periodicExportTimes_input
      };

      let url = '/api/sec/employeeexit/periodicExportSettings/bulk';
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: "put",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).catch(function (error) {
        view.$helpers.error(
            view.$t('global.messages.error'),
            view.$t('export.comp.savePeriodicExportTimesError')
        );
      });
    },
    deletePeriodicExportTime(index) {
      let view = this;
      let elementAtIndex = view.periodicExportTimes_input[index];

      // remove remote if it has id
      if (elementAtIndex.id !== undefined) {
        console.log("element had id");
        this.$helpers.DeleteCall('/api/sec/employeeexit/periodicExportSettings/' + elementAtIndex.id, elementAtIndex)
        .then((response) => {
          let idx = view.periodicExportTimes.indexOf(view.periodicExportTimes.find(time => time.id === elementAtIndex.id));
          // remove locally
          view.periodicExportTimes.splice(idx, 1);
          view.periodicExportTimes_input.splice(index, 1);
        }).catch((e) => {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorDeletingTime')
          );
        });
      } else {
        console.log("element did not have id");
        // remove from input array only
        view.periodicExportTimes_input.splice(index, 1);
      }
    },
    getPeriodicTimeTypeInputs(type) {
      switch(type) {
        case 1: return [
          { label: this.$t('global.time.sundays'), value: 0 },
          { label: this.$t('global.time.mondays'), value: 1 },
          { label: this.$t('global.time.tuesdays'), value: 2 },
          { label: this.$t('global.time.wednesdays'), value: 3 },
          { label: this.$t('global.time.thursdays'), value: 4 },
          { label: this.$t('global.time.fridays'), value: 5 },
          { label: this.$t('global.time.saturdays'), value: 6 }
        ];
        case 2:
          let items = [];
          for (let i = 0; i <= 30; i++) {
            items.push({ label: this.$t('global.time.dayOfMonth', { day: i + 1 }), value: i});
          }
          items.push({ label: this.$t('global.time.lastDayOfMonth'), value: 31 });
          return items;
        default: return [];
      }
    },
    getPeriodicTimeLabel(time) {
      let view = this;
      let values = view.getPeriodicTimeTypeInputs(time.type);
      let label = "";

      let hours = parseInt(time.hours);
      if (hours > 23) {
        time.hours = 23;
      } else if (hours < 10) {
        time.hours = "0" + hours;
      } else {
        time.hours = hours;
      }

      let minutes = parseInt(time.minutes);
      if (minutes > 59) {
        time.minutes = 59;
      } else if (minutes < 10) {
        time.minutes = "0" + minutes;
      } else {
        time.minutes = minutes;
      }

      switch (time.type) {
        case 0: return time.hours + ":" + time.minutes;
        case 1: label = values[time.dayOfWeek].label; break;
        case 2: label = values[time.dayOfMonth].label; break;
      }
      return label + this.$t('export.comp.at') + time.hours + ":" + time.minutes;
    },
    onHoursInput(time) {
      let val = Number(time.hours);

      if (val > 23) val = 23;
      if (val < 0) val = 0;

      time.hours = String(val).padStart(2, '0');
    },
    onMinutesInput(time) {
      let val = Number(time.minutes);

      if (val > 59) val = 59;
      if (val < 0) val = 0;

      time.minutes = String(val).padStart(2, '0');
    },

    // export jobs
    loadExportJobs() {
      let view = this;

      let url = '/api/sec/employeeexit/exports';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.exportJobs = response.data;

        Object.values(view.exportJobs).forEach((elem) => {
          elem.jobStarted = elem.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(elem.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobEnded = elem.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(elem.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobFailed = elem.jobFailed != null ? view.$helpers.convertUTCDateStringTZ(elem.jobFailed, 'DD.MM.YYYY HH:mm:ss') : null;
          view.setExportStatus(elem);
          view.loadAuthuser(elem.authuserId);
        });
      }).catch((e) => {

      });
    },
    setDeltaCalculationFlag: function(exportJob) {
      let view = this;
      let url = "/api/sec/employeeexit/exports/setDeltaCalculationFlag";
      let payload = {
        exportJobId: exportJob.id,
        useForDeltaCalculation: exportJob.useForDeltaCalculation
      };
      return view.$helpers.EditCall(url, payload, null, null, null, null);
    },
    setExportStatus(exportJob) {
      exportJob.status = "DONE"
      if (!exportJob.jobEnded) {
        exportJob.status = "FAILED";
      } else if (exportJob.employeeWarnings) {
        let jsonWarnings = JSON.parse(exportJob.employeeWarnings);

        let otherWarnings = 0;
        let ignorableWarnings = 0;
        let hardIgnorableWarnings = 0;

        Object.values(jsonWarnings).forEach(empWarnings => {
          Object.values(empWarnings.warnings).forEach(warning => {
            if (this.ignorableWarnings.includes(warning)) {
              ignorableWarnings++;
            } else if (this.hardIgnorableWarnings.includes(warning)) {
              hardIgnorableWarnings++;
            } else {
              otherWarnings++;
            }
          })
        });

        if (otherWarnings > 0) {
          exportJob.status = "WARNING";
        } else if (ignorableWarnings > 0) {
          exportJob.status = "IGNORE-WARNING";
        } else if (hardIgnorableWarnings > 0) {
          exportJob.status = "DONE"; // maybe add some other status. really ignore those for now
        }
      }
    },
    getInactiveEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: Inactive Employee"));
    },
    getExternalEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: External Employee"));
    },
    getHiddenEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: Hidden Employee"));
    },
    getOtherWarningsTable(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      let table = [];

      Object.values(jsonWarnings).forEach(empWarnings => {
        Object.values(empWarnings.warnings).forEach(warning => {
          if (!this.ignorableWarnings.includes(warning) && !this.hardIgnorableWarnings.includes(warning)) {
            if (!table.find(w => w.name === warning)) {
              table.push({name: warning, emps: []});
            }
            if (!table.find(w => w.name === warning).emps.includes(empWarnings.employeeId)) {
              table.find(w => w.name === warning).emps.push(empWarnings.employeeId);
            }
          }
        })
      });
      return table;
    },
    getEmployeeName(empId) {
      let view = this;
      let emp = view.employeeArray.find(emp => emp.id === empId);
      if (emp) {
        return emp.firstName + " " + emp.lastName;
      } else {
        return "";
      }
    },
    jobCreated: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.exportJobs.push(e.data.job);
      }, 50);
    },
    jobStarted: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        let job = view.exportJobs.find(j => j.id === e.data.job.id);
        if (job) {
          job.jobStarted = view.$helpers.convertUTCDateStringTZ(e.data.job.jobStarted, 'DD.MM.YYYY HH:mm:ss');
          view.$forceUpdate();
        }
      }, 100);
    },
    jobEnded: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        let job = view.exportJobs.find(j => j.id === e.data.job.id);
        if (job) {
          job.jobEnded = view.$helpers.convertUTCDateStringTZ(e.data.job.jobEnded, 'DD.MM.YYYY HH:mm:ss');
          job.exportCSV = e.data.job.exportCSV;
          job.employeeWarnings = e.data.job.employeeWarnings;
          view.setExportStatus(job);
          view.$forceUpdate();
        }
      }, 200);
    },
    jobFailed: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB FAILED EVENT GOT TRIGGERED");
        let job = view.exportJobs.find(j => j.id === e.data.job.id);
        if (job) {
          job.jobFailed = view.$helpers.convertUTCDateStringTZ(e.data.job.jobFailed, 'DD.MM.YYYY HH:mm:ss');
          view.$forceUpdate();
        }
      }, 200);
    },

    // preview
    loadPreview() {
      let view = this;
      view.buildingPreviewTable = true;

      let url = '/api/sec/employeeexit/export/preview';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);

      return this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.preview = response.data.data;
      }).catch((e) => {
        view.preview = [];
        view.$helpers.error(
            view.$t('global.messages.error'),
            view.$t('export.comp.previewGenerationError')
        );
      }).finally(() => {
        view.buildingPreviewTable = false;
      });
    },

    // export
    exportCSV() {
      let view = this;
      view.loadingExport = true;

      let url = '/api/sec/employeeexit/export';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.loadingExport = false;
        view.$helpers.info(
          view.$t('global.messages.info'),
          view.$t('employee.export.exportTriggered')
        );
      }).catch((e) => {
        view.loadingExport = false;
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.createExportError')
        );
      });
    },

    // download
    openDownloadCsvPopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
          entries: [{
            label: view.$t('export.comp.markEmployeesAsExported'),
            key: "useForDeltaCalculation",
            hidden: false,
            type: "bool",
          }],
          positiveButtonLabel: view.$t('export.comp.downloadCsvExport'),
          selectCallback: function (entity, event) {
            view.downloadCSV(entity);
          },
          errorCheck: {
          },
        },
        header: view.$t('export.comp.downloadEmployeeExitCsv'),
        expanded: true,
        centered: true,
      });
    },
    downloadCSV(entity) {
      let view = this;
      view.loadingDownload = true;

      let url = '/api/sec/employeeexit/getexport';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
      url = this.$helpers.appendParam("useForDeltaCalculation", entity.useForDeltaCalculation ? 1 : 0, url, baseurl);
      // url = this.$helpers.appendParam("remoteIds", [407,408], url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        console.log(response);
        let csv = response.data.exportCSV;
        let job = response.data;

        job.jobStarted = job.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(job.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
        job.jobEnded = job.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(job.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
        job.jobFailed = job.jobFailed != null ? view.$helpers.convertUTCDateStringTZ(job.jobFailed, 'DD.MM.YYYY HH:mm:ss') : null;
        view.setExportStatus(job);
        view.loadAuthuser(job.authuserId);

        view.exportJobs.push(job);

        //console.log(view.$helpers.b64DecodeUnicode(csv));
        view.downloadCSVFromExportJob(csv);
        view.loadingDownload = false;
      }).catch((e) => {
        console.log(e);
        view.loadingDownload = false;
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.createExportError')
        );
      });
    },
    downloadCSVFromExportJob(base64) {
      let view = this;
      view.$helpers.forceFileDownload(view.$helpers.b64DecodeUnicode(base64), "EmployeeExitExport.csv");
    },

    // modals
    openExportJobStatusModal() {
      this.$refs["modal-exportjob-status"].show();
    },
    closeExportJobStatusModal() {
      this.selectedExportJob = null;
      this.$refs["modal-exportjob-status"].hide();
    },


  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.sub-header {
  font-size: 32px;
  text-align: left;
  color: #e51550;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  font-weight: 400;
  margin-bottom: 25px;
  width: 100%;
}

.table > thead > tr > th {
  border-top: 0;
}

.xColumn2 {
  width: 48%;
  text-align: left;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.xColumn2 > .header {
  display: inline-block;
  width: 100%;
  color: #e51550;
  font-size: 15px;
  font-weight: 700;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 7px;
}

.entryBox {
  font-size: 13px;
  text-align: left;
  padding: 12px 7px;
}

.entryBox .entryHeader {
  display: inline-block;
  width: 50%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox .entryHeaderLight {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox .entryData {
  display: inline-block;
  width: 50%;
  float: right;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryHeader.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox.triple .entryHeader {
  display: inline-block;
  width: 25%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox.triple .entryHeaderLight.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryHeaderLight {
  display: inline-block;
  width: 25%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryData.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryData {
  display: inline-block;
  width: 25%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.btn-ml {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}

.btn-ml:hover {
  color: #fff;
  background-color: #cc1347;
  border-color: #cc1347;
}

.table th {
  vertical-align: middle;
}

</style>
